import React from "react";
import { Box, Link, Typography } from "@mui/material";
import FMBlogo from "../../assets/FMBlogo1.png";
import Swal from 'sweetalert2';

const UserFooter = ({company_id}) => {
    // Get the appropriate logo based on company_id, fallback to default
    const getLogoPath = () => {
        if (!company_id) {
            return FMBlogo; // Default logo when no company_id
        }
        
        try {
            // Try to load company-specific logo
            return require(`../../assets/FMBlogo${company_id}.png`);
        } catch (error) {
            // Fallback to default logo if company-specific logo doesn't exist
            console.warn(`Logo for company ${company_id} not found, using default logo`);
            return FMBlogo;
        }
    };

    // Handle logout with confirmation
    const handleLogout = async (e) => {
        e.preventDefault();
        
        try {
            const result = await Swal.fire({
                title: 'Bekreft utlogging',
                text: "Er du sikker på at du vil logge ut?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ja, logg ut',
                cancelButtonText: 'Avbryt',
                reverseButtons: true,
                focusCancel: true // Focus on Cancel button by default
            });

            if (result.isConfirmed) {
                // Redirect to logout page
                window.location.href = '/logout';
            }
        } catch (error) {
            console.error('Error in logout confirmation:', error);
        }
    };

    return (
        <Box 
            textAlign="center" 
            py={{ xs: 2, sm: 3 }} 
            sx={{ 
                mt: 4,
                px: { xs: 1, sm: 2 }
            }}
        >
            {/* Responsive centered container */}
            <Box sx={{ 
                width: { xs: "95%", sm: "80%", md: "60%" }, 
                mx: "auto",
                maxWidth: "800px"
            }}>
                {/* Main content box with responsive styling */}
                <Box sx={{ 
                    p: { xs: 1.5, sm: 2 }, 
                    border: "1px solid #ccc",
                    borderRadius: { xs: 1, sm: 2 }
                }}>
                    {/* Logo with responsive sizing */}
                    <Box sx={{ mb: 2 }}>
                        <img
                            src={getLogoPath()}
                            alt="Fargerike Logo"
                            style={{ 
                                height: "auto",
                                maxHeight: "80px",
                                width: "auto",
                                maxWidth: "200px"
                            }}
                        />
                    </Box>
                    
                    {/* Address link with responsive styling */}
                    <Box sx={{ mb: 2 }}>
                        <Link
                            href="https://maps.google.com"
                            target="_blank"
                            underline="hover"
                            sx={{
                                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
                                fontWeight: "medium"
                            }}
                        >
                            Sørkedalsveien 10,<br /> 
                            Colosseum Senter
                        </Link>
                    </Box>
                    
                    {/* Email with responsive styling */}
                    <Box sx={{ mb: 2 }}>
                        <Typography sx={{
                            fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" }
                        }}>
                            Email:{" "}
                            <Link 
                                href="mailto:butikk@fargerikemajorstuen.no"
                                sx={{ 
                                    fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                                    wordBreak: "break-all"
                                }}
                            >
                                butikk@fargerikemajorstuen.no
                            </Link>
                        </Typography>
                    </Box>
                    
                    {/* Opening hours with responsive styling */}
                    <Box>
                        <Typography sx={{
                            fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                            mt: 1
                        }}>
                            Åpningstider: <br />
                            Man-Fre 06:30 - 18:00 <br />
                            Lør 08-15:30
                        </Typography>
                    </Box>
                </Box>

                {/* Footer links with responsive layout */}
                <Box 
                    mt={2} 
                    sx={{ 
                        display: "flex", 
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        justifyContent: "center",
                        gap: { xs: 1, sm: 2 }
                    }}
                >
                    <Link 
                        href="#" 
                        underline="hover" 
                        sx={{ 
                            fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                            order: { xs: 1, sm: 1 }
                        }}
                    >
                        Personvernerklæring
                    </Link>
                    <Link 
                        href="#" 
                        onClick={handleLogout}
                        underline="hover" 
                        color="error"
                        sx={{ 
                            fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                            order: { xs: 2, sm: 2 },
                            cursor: 'pointer'
                        }}
                    >
                        LOG UT
                    </Link>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            mt: { xs: 1, sm: 0 },
                            fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
                            order: { xs: 3, sm: 3 }
                        }}
                    >
                        © Digifront.biz - 2025
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default UserFooter;
